import styled from "styled-components";
import { token } from "./token.js";
import { Divider as Divider$1 } from "./Divider.js";
const Divider = styled(Divider$1).withConfig({
  displayName: "Divider",
  componentId: "sc-vm95v0-0"
})(["margin:", " ", ";"], token.spacing2, token.spacing4);
export {
  Divider
};
//# sourceMappingURL=Divider3.js.map
